module.exports = __webpack_public_path__ + "static/media/closed-captioning-support-icon.c1ce24eb.svg";